import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { configStore } from "./helpers/store";
import "leaflet/dist/leaflet.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // disable React Query automatically requests fresh data for you in the background
      //         // retry: 0,
      //         suspense: true, // allow use suspense
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={configStore}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("tc_map")
);
